import * as React from "react";
import {Collapse, List, ListItemButton, ListItemIcon, ListItemText} from "@mui/material";
import {Link} from "react-router-dom";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import {useCookies} from "react-cookie";
import {useEffect} from "react";
import {NAV_ICONS} from "./navIcons";


export default function NavList(props){
	let definition = props.definition;
	let securities = props.securities;
	let level = props.level;
	let isMobile = props.isMobile === true;
	const [cookies, setCookie] = useCookies(['navItems']);
	const clientOrigin = window.location.origin;

	const resolveNavUrl = (url) => {
		if(typeof url !== 'string')
			return url;

		try {
			const parsed = new URL(url, `${clientOrigin}/`);
			const isSameOrigin = parsed.origin === clientOrigin;
			const isHardcodedReservoir = /^https?:\/\/reservoir\.usalco\.com$/i.test(parsed.origin);

			if(isSameOrigin || isHardcodedReservoir)
				return `${parsed.pathname}${parsed.search}${parsed.hash}`;
		}catch (error){
			return url;
		}

		return url;
	};

	useEffect(() => {
		if(typeof cookies['navItems'] !== "object")
			setCookie('navItems', []);
	}, [cookies, setCookie]);

	const getChildren = ((item) => {
		let children = [];
		if(item.hasOwnProperty('children') && item.children.length > 0){
			item.children.forEach((value) => {
				children.push(value.id);
				children.concat(getChildren(value));
			});
		}
		return children;
	});

	const toggleCollapse = ((item) => {
		if(cookies['navItems'].indexOf(item.id) !== -1){
			// Remove the ID of this item and all of its children.
			let children = getChildren(item);
			let newOpen = cookies['navItems'].filter((value) => {
				return value !== item.id && children.indexOf(value) === -1;
			});

			setCookie('navItems', newOpen);
		}else{
			let newOpen = [...cookies['navItems'], item.id];
			setCookie('navItems', newOpen);
		}
	});

	let navItems = cookies['navItems'] || [];
	return(
		<List
			component={ level===1 ? 'nav' : 'div' }
			sx={ level!==1 ? null : { width: '100%', maxWidth: isMobile ? 'none' : 360, bgcolor: '#ffffff', pt: 0, pb: 0, mt: 0 } }

			disablePadding={level !== 1}
			dense={!isMobile}
		>
			{
				definition.map((item, index) => {
					// Security lives on the destination (report/page), not the nav item. Hide a
					// link when its destination is secured and the user lacks the grant. The
					// server (getChildren) already filters these out; this is a second layer.
					if(item.report_security===1 && (!Array.isArray(securities) || (securities.filter((value) => { return value.ua_fid===item.report_id; }).length===0)))
						return null;
					if(item.page_security===1 && (!Array.isArray(securities) || (securities.filter((value) => { return value.ua_fid===item.page_id; }).length===0)))
						return null;
					// "Hidden" nav item: shown only to users granted the nav item itself
					// (user_access ua_type='navigation', ua_fid=nv_guid). The server
					// (getChildren) already filters these out; this is a second layer.
					if(item.hidden===1 && (!Array.isArray(securities) || (securities.filter((value) => { return value.ua_fid===item.id; }).length===0)))
						return null;

					return (
						<React.Fragment key={item.id}>
							{(() => {
								const navUrl = item.hasOwnProperty('url') ? resolveNavUrl(item.url) : undefined;
								const isExternal = typeof navUrl === 'string' && navUrl.startsWith('http');

								return (
							<ListItemButton
								component={item.hasOwnProperty('url') && item.url !== null ? (isExternal ? 'a' : Link) : undefined}
								to={!isExternal && item.hasOwnProperty('url') ? navUrl : undefined}
								href={isExternal ? navUrl : undefined}
								disabled={!((item.hasOwnProperty('url') && item.url !== null) || (item.hasOwnProperty('children') && item.children.length > 0))}
								sx={{ pl: ((level-1)*2)+1, py: isMobile ? 1 : 0.4, minHeight: isMobile ? 44 : 34 }}
								onClick={!(item.hasOwnProperty('url') && item.url !== null) ? () => toggleCollapse(item) : undefined}
							>
								<ListItemIcon sx={{ minWidth: isMobile ? 36 : 32 }}>
									{ item.hasOwnProperty('icon') && NAV_ICONS.hasOwnProperty(item.icon) ? React.createElement(NAV_ICONS[item.icon]) : null }
								</ListItemIcon>
								<ListItemText primary={item.label} sx={{ margin: 0 }} />
								{ item.hasOwnProperty('children') && item.children.length > 0 ? navItems.indexOf(item.id) !== -1 ? <ExpandLess /> : <ExpandMore /> : null }
							</ListItemButton>
								);
							})()}

							{
								item.hasOwnProperty('children') && item.children.length > 0 ? <Collapse in={navItems.indexOf(item.id) !== -1} timeout="auto" unmountOnExit><NavList definition={item.children} level={(level+1)} securities={securities} /></Collapse> : null
							}

						</React.Fragment>
					);
				})
			}
		</List>
	);
}

